import styled from 'styled-components';

export const defaultTheme = {
  layer: {
    base: '#FAFAFA',
    1: '#FFFFFF',
    12: '#E4E6EA',
    2: '#E4E6EA',
    3: '#A4A9B1',
    4: '#868E99'
  },
  border: {
    base: '#C7CBD2'
  },
  action: {
    primary: '#4587EC',
    default: '#1C488A',
    active: '#3AB070',
    hover: '#1C488A',
    disabled: '#DEDEDE'
  },
  font: {
    base: '#373F4E',
    weak: '#7F7F7F',
    strong: '#2E2E2E',
    disabled: '#ABABAB',
    action: '#4587EC'
  },
  header: {
    base: '#36474F',
    action: '#FAFAFA',
    layer2: '#465D67'
  },
  footer: {
    base: '#36474F'
  },
  context: {
    error: '#D63B4B',
    warning: '#EF9208',
    caution: '#EFD809',
    success: '#3DBD4A',
    light: '#F4F5F6'
  },
  menu: {
    tab: '#36474F',
    active: '#3AB070'
  },
  loginBg: '#36474F'
};

export const darkTheme = {
  layer: {
    base: '#111827',
    1: '#000000',
    12: '#2A2E3F',
    2: '#2A2E3F',
    3: '#373F4E',
    4: '#545C6B'
  },
  border: {
    base: '#6B7280'
  },
  action: {
    primary: '#4587EC',
    default: '#1C488A',
    active: '#5CCF91',
    hover: '#245FB9',
    disabled: '#2A2E3F'
  },
  font: {
    base: '#F0F1F3',
    weak: '#ABABAB',
    strong: '#FAFAFA',
    disabled: '#545C6B',
    action: '#90BBFB'
  },
  header: {
    base: '#373F4E',
    action: '#FAFAFA',
    layer2: '#465D67'
  },
  footer: {
    base: '#373F4E'
  },
  context: {
    error: '#D63B4B',
    warning: '#EF9208',
    caution: '#EFD809',
    success: '#3DBD4A',
    light: '#F4F5F6'
  },
  menu: {
    tab: '#373F4E',
    active: '#5CCF91'
  },
  loginBg: '#2A2E3F'
};

export const fegTheme = {
  layer: {
    base: '#FAFAFA',
    1: '#FFFFFF',
    12: '#F4F5F6',
    2: '#F0F1F3',
    3: '#A4A9B1',
    4: '#868E99'
  },
  border: {
    base: '#C7CBD2'
  },
  action: {
    primary: '#00AEEF',
    default: '#1C488A',
    active: '#FBB161',
    hover: '#203864',
    disabled: '#DEDEDE'
  },
  font: {
    base: '#202020',
    weak: '#919195',
    strong: '#111827',
    disabled: '#ABABAB',
    action: '#00AEEF'
  },
  header: {
    base: '#919195',
    action: '#FAFAFA',
    layer2: '#7F7F7F'
  },
  footer: {
    base: '#36474F'
  },
  context: {
    error: '#B5121B',
    warning: '#EF9208',
    caution: '#FFF9AE',
    success: '#72A492',
    light: '#F4F5F6'
  },
  menu: {
    tab: '#919195',
    active: '#FBB161'
  },
  loginBg: '#F0F1F3'
};

export const iapTheme = {
  layer: {
    base: '#FAFAFA',
    1: '#FFFFFF',
    12: '#F4F5F6',
    2: '#F0F1F3',
    3: '#A4A9B1',
    4: '#868E99'
  },
  border: {
    base: '#C7CBD2'
  },
  action: {
    primary: '#452032',
    default: '#141D31',
    active: '#141D31',
    hover: '#141D31',
    disabled: '#DEDEDE'
  },
  font: {
    base: '#2A2E3F',
    weak: '#7F7F7F',
    strong: '#111827',
    disabled: '#ABABAB',
    action: '#452032'
  },
  header: {
    base: '#452032',
    action: '#FAFAFA',
    layer2: '#800000'
  },
  footer: {
    base: '#141D31'
  },
  context: {
    error: '#B5121B',
    warning: '#EF9208',
    caution: '#EFD809',
    success: '#3DBD4A',
    light: '#F4F5F6'
  },
  menu: {
    tab: '#452032',
    active: '#800000'
  },
  loginBg: '#452032'
};

export const insigneoTheme = {
  layer: {
    base: '#FAFAFA',
    1: '#FFFFFF',
    12: '#F4F5F6',
    2: '#F0F1F3',
    3: '#A4A9B1',
    4: '#868E99'
  },
  border: {
    base: '#C7CBD2'
  },
  action: {
    primary: '#2E5EAA',
    default: '#40B1E4',
    active: '#1E3765',
    hover: '#1E3765',
    disabled: '#DEDEDE'
  },
  font: {
    base: '#2A2E3F',
    weak: '#7F7F7F',
    strong: '#111827',
    disabled: '#ABABAB',
    action: '#2E5EAA'
  },
  header: {
    base: '#002634',
    action: '#F8F9FA',
    layer2: '#465D67'
  },
  footer: {
    base: '#141D31'
  },
  context: {
    error: '#B5121B',
    warning: '#EF9208',
    caution: '#EFD809',
    success: '#3DBD4A',
    light: '#F4F5F6'
  },
  menu: {
    tab: '#002634',
    active: '#BEA57C'
  },
  loginBg: '#002634'
};

export const darkThemeOld = {
  divider: '#2D3748',
  neutral: {
    100: '#F3F4F6',
    200: '#E5E7EB',
    300: '#D1D5DB',
    400: '#9CA3AF',
    500: '#6B7280',
    600: '#4B5563',
    700: '#374151',
    800: '#1F2937',
    900: '#111827'
  },
  action: {
    primary: '#49A992',
    default: '#26497E',
    active: '#75D8C1',
    defaultHover: '#3164B0',
    primaryHover: '#FAFAFA',
    defaultDisabled: '#2A2E3F',
    primaryDisabled: '#FAFAFA'
  },
  background: {
    default: '#0B0F19',
    paper: '#FFFFFF'
  },
  primary: {
    main: '#111827',
    light: '#000000',
    dark: '#2A2E3F',
    contrastText: '#FFFFFF'
  },
  secondary: {
    main: '#373F4E',
    light: '#545C6B',
    dark: '#545C6B',
    contrastText: '#F4F5F6'
  },
  success: {
    main: '#3DBD4A',
    light: '#43C6B7',
    dark: '#0E8074',
    contrastText: '#FFFFFF'
  },
  info: {
    main: '#2196F3',
    light: '#64B6F7',
    dark: '#0B79D0',
    contrastText: '#FFFFFF'
  },
  warning: {
    main: '#EF9208',
    light: '#FFBF4C',
    dark: '#B27B16',
    contrastText: '#FFFFFF'
  },
  error: {
    main: '#D63B4B',
    light: '#DA6868',
    dark: '#922E2E',
    contrastText: '#FFFFFF'
  },
  text: {
    primary: '#EDF2F7',
    secondary: '#A0AEC0',
    disabled: 'rgba(255, 255, 255, 0.48)'
  },
  font: {
    base: '#F0F1F3',
    weak: '#ABABAB',
    strong: '#FAFAFA',
    disabled: '#545C6B',
    action: '#97BEFA',
    actionHover: '#FAFAFA',
    disabledHover: '#FAFAFA'
  },
  body: {
    header: '#373F4E',
    headerAction: '#FAFAFA',
    footer: '#373F4E'
  },
  shadows: [
    'none',
    '0px 1px 2px rgba(0, 0, 0, 0.24)',
    '0px 1px 2px rgba(0, 0, 0, 0.24)',
    '0px 1px 4px rgba(0, 0, 0, 0.24)',
    '0px 1px 5px rgba(0, 0, 0, 0.24)',
    '0px 1px 6px rgba(0, 0, 0, 0.24)',
    '0px 2px 6px rgba(0, 0, 0, 0.24)',
    '0px 3px 6px rgba(0, 0, 0, 0.24)',
    '0px 4px 6px rgba(0, 0, 0, 0.24)',
    '0px 5px 12px rgba(0, 0, 0, 0.24)',
    '0px 5px 14px rgba(0, 0, 0, 0.24)',
    '0px 5px 15px rgba(0, 0, 0, 0.24)',
    '0px 6px 15px rgba(0, 0, 0, 0.24)',
    '0px 7px 15px rgba(0, 0, 0, 0.24)',
    '0px 8px 15px rgba(0, 0, 0, 0.24)',
    '0px 9px 15px rgba(0, 0, 0, 0.24)',
    '0px 10px 15px rgba(0, 0, 0, 0.24)',
    '0px 12px 22px -8px rgba(0, 0, 0, 0.24)',
    '0px 13px 22px -8px rgba(0, 0, 0, 0.24)',
    '0px 14px 24px -8px rgba(0, 0, 0, 0.24)',
    '0px 20px 25px rgba(0, 0, 0, 0.24)',
    '0px 25px 50px rgba(0, 0, 0, 0.24)',
    '0px 25px 50px rgba(0, 0, 0, 0.24)',
    '0px 25px 50px rgba(0, 0, 0, 0.24)',
    '0px 25px 50px rgba(0, 0, 0, 0.24)'
  ]
};

export const lightThemeOld = {
  divider: '#AEAEB0',
  errorText: '#EB0028',
  defaultInput: '#D9D9D9',
  tableHeading: '#E1E1E1',
  white: '#FFFF',
  passwordLabelText: '#004052',
  resetPasswordInput: '#EFEFEF',
  action: {
    primary: '#2E7967',
    default: '#172D4D',
    active: '#3AB070',
    defaultHover: '#26497E',
    primaryHover: '#F4F5F6',
    defaultDisabled: '#DEDEDE',
    primaryDisabled: '#F4F5F6',
    primarySave: '#4587EC'
  },
  background: {
    default: '#FAFAFA',
    paper: '#FFFFFF'
  },
  primary: {
    main: '#FAFAFA',
    light: '#FFFFFF',
    dark: '#F0F1F3',
    contrastText: '#FFFFFF'
  },
  secondary: {
    main: '#A4A9B1',
    light: '#C7CBD2',
    dark: '#868E99',
    contrastText: '#F4F5F6'
  },
  text: {
    primary: '#111827',
    secondary: '#6B7280',
    light: '#91969E',
    main: '#33363F'
  },
  success: {
    main: '#3DBD4A',
    light: '#94e3a1',
    dark: '#0E8074',
    contrastText: '#FFFFFF'
  },
  info: {
    main: '#E1E6E9',
    light: '#AFB8BC',
    dark: '#0B79D0',
    contrastText: '#FFFFFF'
  },
  error: {
    main: '#D63B4B',
    light: '#FFDFE5',
    dark: '#922E2E',
    contrastText: '#FFFFFF'
  },
  warning: {
    main: '#EF9208',
    light: '#FFBF4C',
    dark: '#B27B16',
    contrastText: '#FFFFFF'
  },
  fontWeight: {
    light: 300,
    medium: 400,
    heavy: 600
  },
  font: {
    base: '#373F4E',
    weak: '#7F7F7F',
    strong: '#2E2E2E',
    disabled: '#ABABAB',
    action: '#578FE4',
    actionHover: '#F4F5F6',
    disabledHover: '#F4F5F6'
  },
  body: {
    header: '#36474F',
    headerAction: '#FAFAFA',
    footer: '#373F4E'
  }
};

export const slateTheme = {
  neutral: {
    100: '#F3F4F6',
    200: '#E5E7EB',
    300: '#D1D5DB',
    400: '#9CA3AF',
    500: '#6B7280',
    600: '#4B5563',
    700: '#374151',
    800: '#1F2937',
    900: '#111827'
  },
  background: {
    default: '#0B0F19',
    paper: '#111827'
  },
  divider: '#2D3748',
  primary: {
    main: '#7582EB',
    light: '#909BEF',
    dark: '#515BA4',
    contrastText: '#111827'
  },
  secondary: {
    main: '#10B981',
    light: '#3FC79A',
    dark: '#0B815A',
    contrastText: '#111827'
  },
  success: {
    main: '#14B8A6',
    light: '#43C6B7',
    dark: '#0E8074',
    contrastText: '#111827'
  },
  info: {
    main: '#2196F3',
    light: '#64B6F7',
    dark: '#0B79D0',
    contrastText: '#111827'
  },
  warning: {
    main: '#FFB020',
    light: '#FFBF4C',
    dark: '#B27B16',
    contrastText: '#111827'
  },
  error: {
    main: '#D14343',
    light: '#DA6868',
    dark: '#922E2E',
    contrastText: '#111827'
  },
  text: {
    primary: '#EDF2F7',
    secondary: '#A0AEC0',
    disabled: 'rgba(255, 255, 255, 0.48)'
  },
  action: {
    active: '#9CA3AF',
    hover: 'rgba(255, 255, 255, 0.04)',
    selected: 'rgba(255, 255, 255, 0.08)',
    disabledBackground: 'rgba(255, 255, 255, 0.12)',
    disabled: 'rgba(255, 255, 255, 0.26)'
  },
  shadows: [
    'none',
    '0px 1px 2px rgba(0, 0, 0, 0.24)',
    '0px 1px 2px rgba(0, 0, 0, 0.24)',
    '0px 1px 4px rgba(0, 0, 0, 0.24)',
    '0px 1px 5px rgba(0, 0, 0, 0.24)',
    '0px 1px 6px rgba(0, 0, 0, 0.24)',
    '0px 2px 6px rgba(0, 0, 0, 0.24)',
    '0px 3px 6px rgba(0, 0, 0, 0.24)',
    '0px 4px 6px rgba(0, 0, 0, 0.24)',
    '0px 5px 12px rgba(0, 0, 0, 0.24)',
    '0px 5px 14px rgba(0, 0, 0, 0.24)',
    '0px 5px 15px rgba(0, 0, 0, 0.24)',
    '0px 6px 15px rgba(0, 0, 0, 0.24)',
    '0px 7px 15px rgba(0, 0, 0, 0.24)',
    '0px 8px 15px rgba(0, 0, 0, 0.24)',
    '0px 9px 15px rgba(0, 0, 0, 0.24)',
    '0px 10px 15px rgba(0, 0, 0, 0.24)',
    '0px 12px 22px -8px rgba(0, 0, 0, 0.24)',
    '0px 13px 22px -8px rgba(0, 0, 0, 0.24)',
    '0px 14px 24px -8px rgba(0, 0, 0, 0.24)',
    '0px 20px 25px rgba(0, 0, 0, 0.24)',
    '0px 25px 50px rgba(0, 0, 0, 0.24)',
    '0px 25px 50px rgba(0, 0, 0, 0.24)',
    '0px 25px 50px rgba(0, 0, 0, 0.24)',
    '0px 25px 50px rgba(0, 0, 0, 0.24)'
  ]
};

// Helper function to flatten theme object and convert to CSS custom properties
export const themeToCSSVariables = (theme: any, prefix = '--theme'): Record<string, string> => {
  const cssVars: Record<string, string> = {};

  const flattenObject = (obj: any, currentPrefix: string) => {
    Object.keys(obj).forEach((key) => {
      const value = obj[key];
      const newPrefix = `${currentPrefix}-${key}`;

      if (typeof value === 'object' && value !== null) {
        flattenObject(value, newPrefix);
      } else {
        cssVars[newPrefix] = value;
      }
    });
  };

  flattenObject(theme, prefix);
  return cssVars;
};

// Function to apply theme as CSS custom properties to document root
export const applyThemeToDOM = (theme: any) => {
  const cssVars = themeToCSSVariables(theme);
  const root = document.documentElement;

  Object.entries(cssVars).forEach(([property, value]) => {
    root.style.setProperty(property, value);
  });
};

// Function to get CSS variable value from theme path
export const getThemeCSSVariable = (path: string): string => {
  return `var(--theme-${path.replace(/\./g, '-')})`;
};

// Utility function for styled-components to use CSS custom properties
export const themeVar = (path: string): string => {
  return `var(--theme-${path.replace(/\./g, '-')})`;
};

// Alternative: Create a theme helper that returns both the theme value and CSS variable
export const createThemeHelper = (theme: any) => {
  return {
    // Get theme value (for styled-components)
    get: (path: string) => {
      return path.split('.').reduce((obj, key) => obj?.[key], theme);
    },
    // Get CSS variable (for debugging in dev tools)
    var: (path: string) => themeVar(path),
    // Get both (for components that need both)
    both: (path: string) => ({
      value: path.split('.').reduce((obj, key) => obj?.[key], theme),
      cssVar: themeVar(path)
    })
  };
};

// Alternative approach: Add data attributes to show theme variable names
export const createThemeDebugger = (theme: any) => {
  return {
    // Add data attributes to an element for debugging
    addDebugAttributes: (element: HTMLElement, themePath: string) => {
      element.setAttribute('data-theme-var', themePath);
      element.setAttribute(
        'data-theme-value',
        themePath.split('.').reduce((obj, key) => obj?.[key], theme)
      );
    },

    // Create a styled component wrapper that adds debug attributes
    withDebug: (Component: any, themePath: string) => {
      return styled(Component)`
        &::before {
          content: 'theme: ${themePath}';
          position: absolute;
          top: -20px;
          left: 0;
          font-size: 10px;
          color: red;
          background: white;
          padding: 2px 4px;
          border: 1px solid red;
          z-index: 9999;
          display: none;
        }

        &:hover::before {
          display: block;
        }
      `;
    }
  };
};

export const jsonEditorTheme = {
  displayName: 'Default',
  styles: {
    container: {
      fontFamily: 'Blinker',
      backgroundColor: 'transparent',
      padding: 0,
      marginLeft: '20px'
    },
    property: themeVar('font.strong'),
    itemCount: { color: themeVar('font.weak'), fontStyle: 'italic' },
    string: themeVar('context.error'),
    number: themeVar('font.action'),
    boolean: 'green',
    null: { color: themeVar('context.error'), fontWeight: 400, fontVariant: 'normal' },
    input: [
      themeVar('font.strong'),
      {
        fontSize: '16px',
        lineHeight: '18.2px',
        backgroundColor: themeVar('layer.1'),
        border: `1px solid ${themeVar('border.base')}`,
        padding: '8px 5px',
        borderRadius: '3px'
      }
    ],
    error: { fontSize: '16px', fontWeight: 400, color: themeVar('context.error'), lineHeight: '22.4px', marginLeft: 0 }
  }
};
